jQuery(document).ready(function ($) {
  const hash = window.location.hash;
  const params = new URLSearchParams(window.location.search);
  const shouldOpen =
    hash === "#contact_form" || params.get("customer_posted") === "true";

  if (shouldOpen) {
    const tryOpen = () => {
      const $btn = $("#popup_click_btn");
      if ($btn.length) {
        $btn.find('.code strong').text(`HAPPYDAYS10`);
        $btn.fadeIn();
        return true;
      }
      return false;
    };

    // try immediately, then retry a few times in case the popup script loads late
    if (!tryOpen()) {
      let tries = 0;
      const iv = setInterval(() => {
        tries++;
        if (tryOpen() || tries > 20) clearInterval(iv);
      }, 200);
    }
  }
});
